import React, { useCallback } from 'react';
import { FiservCardInterface, FiservCardStatusEnum } from '@common-fe/common-fe';

import { ModalWrapper } from '@/components/wrappers';
import { useChangeCardStatus } from '@/modules/transaction/Cards/queries/useChangeCardStatus.query';

import { CardAccessConfirmationModal } from './CardAccessConfirmationModal';
import CardAccessFormModal from './CardAccessFormModal';
import { useCardAccessModal } from './hooks';

interface Props {
  card?: FiservCardInterface;
  visible: boolean;
  onChangeCardAccessModalVisible?: () => void;
  onHideVisibility?: (value: boolean) => void;
  refreshCardList?: () => void;
}

export const CardAccessModal: React.FC<Props> = ({
  card,
  visible,
  onHideVisibility,
  onChangeCardAccessModalVisible,
  refreshCardList,
}) => {
  const {
    isConfirmationMode,
    lockedPursesIds,
    isCardLocked,
    isEmployeeUnlockForbidden,
    lockReason,
    handleSetConfirmationMode,
    handleCancel,
    handleEmployeeUnlockForbidden,
  } = useCardAccessModal(card, visible, onChangeCardAccessModalVisible, onHideVisibility);

  const {
    mutateAsync: changeStatusMutation,
    isPending: isLoading,
  } = useChangeCardStatus();

  const handleChangeStatusMutationHandler = useCallback(async (status: FiservCardStatusEnum) => {
    if (card) {
      await changeStatusMutation({ id: card?.id, status, lockedPursesIds, isEmployeeUnlockForbidden, lockReason });
      handleCancel();
      setTimeout(() => refreshCardList?.(), 500);
    }
  }, [card, changeStatusMutation, lockedPursesIds, isEmployeeUnlockForbidden, lockReason, handleCancel, refreshCardList]);

  return (
    <>
      {!isConfirmationMode
        ? (
          <ModalWrapper testId="card-access" visible={visible} onSetVisible={handleCancel} title="Update Card Access">
            <CardAccessFormModal
              lockedPursesIds={lockedPursesIds}
              card={card}
              isCardLocked={isCardLocked}
              isLoading={isLoading}
              isEmployeeUnlockForbidden={isEmployeeUnlockForbidden}
              onSetEmployeeUnlockForbidden={handleEmployeeUnlockForbidden}
              onChangeStatusMutationHandler={handleChangeStatusMutationHandler}
              onCancel={handleCancel}
              onSetConfirmationMode={handleSetConfirmationMode}
            />
          </ModalWrapper>
        )
        : (
          <ModalWrapper testId="card-access" visible={visible} onSetVisible={handleCancel} title="Confirm Accounts Lock">
            <CardAccessConfirmationModal
              lockedPursesIds={lockedPursesIds}
              card={card}
              isCardLocked={isCardLocked}
              isLoading={isLoading}
              onChangeStatusMutationHandler={handleChangeStatusMutationHandler}
              onCancel={handleCancel}
            />
          </ModalWrapper>
        )}
    </>
  );
};
